import { DomainList } from "@/components/domain";
import { Skeleton } from "@/components/ui/skeleton";
import { useGetAccommodationsWithFulfillments } from "@/hooks/accommodations";
import { useGetReservation } from "@/hooks/reservations";
import { T } from "@/i18n";
import { BookOpen, EuroIcon } from "lucide-react";
import { HotelFulfillmentView } from "./view-item";
import { useMemo } from "react";
import { HotelFulfillment } from "@/models";

export function ViewHotels({ id }: { id: string }) {
  const { data: reservation, isLoading } = useGetReservation(id);
  const query = useGetAccommodationsWithFulfillments(id);
  const data = useMemo(() => {
    return query.data
      ?.map(
        (d) =>
          d.fulfillments?.map<HotelFulfillment>((f) => ({
            ...f,
            hotelRoomId: d.hotelRoomId,
            hotelId: d.hotelRoom?.hotelId,
          })) ?? [],
      )
      .flat();
  }, [query.data]);
  return (
    <DomainList
      domain="reservations.fulfillments.hotels"
      breadcrumbs={[
        {
          content: (
            <>
              <T tKey="reservations.title" />{" "}
              <BookOpen width={16} height={16} />
            </>
          ),
          href: "/reservations",
        },
        {
          content:
            isLoading || !reservation ? (
              <Skeleton className="h-5 w-10" />
            ) : (
              <>
                {reservation.agencyReservationNumber ?? reservation.id}
                <BookOpen width={16} height={16} />
              </>
            ),
          href: "/reservations/$id",
          params: { id },
        },
        {
          content: (
            <>
              <T tKey="reservations.fulfillments.title" />{" "}
              <EuroIcon width={16} height={16} />
            </>
          ),
          href: "/reservations/$id/fulfillments",
          params: { id },
        },
      ]}
      tableOptions={{
        hasActions: true,
        columns: [
          {
            header: "reservations.fulfillments.table.hotel",
          },
          {
            header: "reservations.fulfillments.table.value",
          },
          {
            header: "reservations.fulfillments.table.dueDate",
          },
          {
            header: "reservations.fulfillments.table.state",
          },
          {
            header: "reservations.fulfillments.table.agencyCharge",
          },
          {
            header: "reservations.fulfillments.table.expenses",
          },
          {
            header: "reservations.fulfillments.table.invoiceNumber",
          },
        ],
      }}
      type="table"
      data={data}
      noOutlet
      isLoading={query.isLoading}
      newLink="/reservations/$id/fulfillments/new/hotel"
      newLinkParams={{ id }}
      renderItem={(fulfillment, _, isTable) => (
        <HotelFulfillmentView
          fulfillment={fulfillment}
          key={fulfillment.id}
          reservationId={id}
          isTable={isTable}
        />
      )}
    />
  );
}
